import { Record } from "immutable";
import { firebase } from "@/firebase/firebaseConfig.js";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const Account = AiseaApiFactory.get("account");
import * as SessionUtil from "../../utils/SessionUtil";
import Vue from "vue";

const Session = Record({
  project_id: null,
  enterprise_id: null,
  marina_id: null,
  login_key: null,
  account_id: null,
  is_project: false,
  is_enterprise: false,
  is_marina: false,
  is_personal: false,
  id_token: ""
});

const state = {
  session: new Session(),
  logout: {
    is_show: false
  },
  refreshTokenIdTimer: null
};

const mutations = {
  updateToken: (state, tokens) => {
    localStorage.setItem("login_key", tokens.login_key);
    localStorage.setItem("id_token", tokens.id_token);
    localStorage.setItem("refresh_token", tokens.refresh_token);
    state.session = state.session.merge({
      project_id: state.session.project_id,
      enterprise_id: state.session.enterprise_id,
      marina_id: state.session.marina_id,
      login_key: tokens.login_key,
      account_id: state.session.account_id,
      is_project: state.session.is_project,
      is_enterprise: state.session.is_enterprise,
      is_marina: state.session.is_marina,
      is_personal: state.session.is_personal,
      id_token: tokens.id_token
    });
  },
  updateClaims: (state, claims) => {
    let loginKey = localStorage.getItem("login_key");
    if (claims.projectId) {
      state.session = state.session.merge({
        project_id: claims.projectId,
        enterprise_id: null,
        marina_id: null,
        login_key: loginKey,
        account_id: claims.accountId,
        is_project: true,
        is_enterprise: false,
        is_marina: false,
        is_personal: false
      });
    } else if (claims.enterpriseId) {
      state.session = state.session.merge({
        project_id: null,
        enterprise_id: claims.enterpriseId,
        marina_id: null,
        login_key: loginKey,
        account_id: claims.accountId,
        is_project: false,
        is_enterprise: true,
        is_marina: false,
        is_personal: false
      });
    } else if (claims.marinaId) {
      state.session = state.session.merge({
        project_id: null,
        enterprise_id: null,
        marina_id: claims.marinaId,
        login_key: loginKey,
        account_id: claims.accountId,
        is_project: false,
        is_enterprise: false,
        is_marina: true,
        is_personal: false
      });
    } else if (claims.userId) {
      state.session = state.session.merge({
        project_id: null,
        enterprise_id: null,
        marina_id: null,
        login_key: loginKey,
        account_id: claims.accountId,
        is_project: false,
        is_enterprise: false,
        is_marina: false,
        is_personal: true
      });
    }

    localStorage.setItem("claims", JSON.stringify(claims));
  },
  clearSession: () => {
    localStorage.removeItem("id_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("login_key");
    localStorage.removeItem("claims");
    localStorage.removeItem("aisea_feature_permissions");
  },
  setShowLogout: (state, isShow) => {
    state.logout.is_show = isShow;
  },
  setRefreshTokenIdTimer: state => {
    state.refreshTokenIdTimer = setInterval(function() {
      //let refreshToken = localStorage.getItem("refresh_token");
      //let customToken = localStorage.getItem("id_token");
      // let params = { grant_type: "refresh_token", refresh_token: refreshToken };
      // default
      //   .post(
      //     "https://securetoken.googleapis.com/v1/token?key=" +
      //       firebaseConfig.apiKey,
      //     { params: params }
      //   )
      //   .then(res => {
      //     // console.log(res.data.access_token);
      //     console.log(res);
      //   })
      //   .catch(e => {
      //     console.log(e);
      //   });
      // firebase
      //   .auth()
      //   .currentUser.getIdTokenResult(true) // trueで強制リフレッシュ
      //   .then(res => {
      //     Vue.$log.info("Refreshed token ID at  ", new Date());
      //     Vue.$log.info("Token ID = ", res.token);
      //     localStorage.setItem("id_token", res.token);
      //     state.session = state.session.merge({
      //       project_id: state.session.project_id,
      //       enterprise_id: state.session.enterprise_id,
      //       marina_id: state.session.marina_id,
      //       login_key: state.session.login_key,
      //       account_id: state.session.account_id,
      //       is_project: state.session.is_project,
      //       is_enterprise: state.session.is_enterprise,
      //       is_marina: state.session.is_marina,
      //       is_personal: state.session.is_personal,
      //       id_token: res.token
      //     });
      //   });
    }, 10000); // 30分;
  },
  clearRefreshTokenIdTimer: state => {
    if (state.refreshTokenIdTimer !== null) {
      clearInterval(state.refreshTokenIdTimer);
    }
  }
};

const actions = {
  update: _context => {
    //const json = localStorage.getItem("claims");
    //const claims = JSON.parse(json);

    // return firebase.auth().onAuthStateChanged((user-management) => {
    //
    //   return user-management.getIdTokenResult().then((result) => {
    //     Vue.$log.info(result)
    //     context.commit("updateToken", {
    //       'id_token': result.token,
    //       'refresh_token': result.refreshToken
    //     });
    //     context.commit("updateClaims", result.claims);
    //   });
    // });
  },
  isLogin: () => {
    if (localStorage.getItem("id_token")) {
      return true;
    }
    return false;
  },
  /**
   * 法人ログイン処理
   * @param context
   * @param loginInfo
   * @returns {*}
   */
  loginForEnterprise: (context, loginInfo) => {
    return Account.loginWithEnterprise({
      enterprise_id: loginInfo.enterprise_id,
      id: loginInfo.login_key,
      password: loginInfo.password
    })
      .then(response => {
        let customToken = response.data.custom_token;

        return firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
          .then(() => firebase.auth().signInWithCustomToken(customToken))
          .then(auth => {
            return auth.user.getIdTokenResult();
          })
          .then(result => {
            Vue.$log.info("============= refresh_token =================");
            Vue.$log.info(result.token);
            Vue.$log.info("============= refresh_token =================");
            Vue.$log.info(response.data.refresh_token);
            context.commit("updateToken", {
              login_key: loginInfo.login_key,
              id_token: result.token,
              refresh_token: response.data.refresh_token
            });
            context.dispatch(
              "account/update",
              {
                name: loginInfo.login_key
              },
              { root: true }
            );
            context.commit("updateClaims", result.claims);
            if (loginInfo.remember_me) {
              SessionUtil.setEnterpriseLoginInfo(loginInfo);
            } else {
              SessionUtil.clearEnterpriseLoginInfo();
            }
          });
      })
      .then(() => {
        context.commit("setRefreshTokenIdTimer");
      });
  },
  /**
   * マリーナログイン処理
   * @param context
   * @param loginInfo
   * @returns {*}
   */
  loginForMarina: (context, loginInfo) => {
    return Account.loginMarina({
      marina_id: loginInfo.marina_id,
      id: loginInfo.login_key,
      password: loginInfo.password
    })
      .then(response => {
        let customToken = response.data.custom_token;
        return firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
          .then(() => firebase.auth().signInWithCustomToken(customToken))
          .then(auth => {
            return auth.user.getIdTokenResult();
          })
          .then(result => {
            context.commit("updateToken", {
              login_key: loginInfo.login_key,
              id_token: result.token,
              refresh_token: response.data.refresh_token
            });
            context.commit("updateClaims", result.claims);
            if (loginInfo.remember_me) {
              SessionUtil.setMarinaLoginInfo(loginInfo);
            } else {
              SessionUtil.clearMarinaLoginInfo();
            }
          });
      })
      .then(() => {
        context.commit("setRefreshTokenIdTimer");
      });
  },
  reLogin: context => {
    const refreshToken = localStorage.getItem("refresh_token");
    const loginKey = localStorage.getItem("login_key");

    const json = localStorage.getItem("claims");
    const obj = JSON.parse(json);

    let promiss = null;

    if (obj.projectId) {
      promiss = Account.loginProject(
        {
          project_id: obj.projectId,
          id: loginKey
        },
        {
          refresh_token: refreshToken
        }
      );
    } else if (obj.enterpriseId) {
      promiss = Account.loginWithEnterprise(
        {
          enterprise_id: obj.enterpriseId,
          id: loginKey
        },
        {
          refresh_token: refreshToken
        }
      );
    } else if (obj.marinaId) {
      promiss = Account.loginMarina(
        {
          marina_id: obj.marinaId,
          id: loginKey
        },
        {
          refresh_token: refreshToken
        }
      );
    } else if (obj.userId) {
      promiss = Account.loginPersonal(
        {
          id: loginKey
        },
        {
          refresh_token: refreshToken
        }
      );
    }

    if (promiss != null) {
      return promiss.then(response => {
        let customToken = response.data.custom_token;

        return firebase
          .auth()
          .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
          .then(() => firebase.auth().signInWithCustomToken(customToken))
          .then(auth => auth.user.getIdTokenResult())
          .then(result => {
            context.commit("updateToken", {
              login_key: loginKey,
              id_token: result.token,
              refresh_token: response.data.refresh_token
            });
            context.commit("updateClaims", result.claims);

            return result.token;
          });
      });
    } else {
      return Promise.reject("eee");
    }
  },
  showLogout: (context, isShow) => {
    context.commit("setShowLogout", isShow);
  },
  /**
   * ログアウト
   * @param context
   */
  logout: context => {
    context.commit("clearRefreshTokenIdTimer");
    firebase
      .auth()
      .signOut()
      .then(function() {
        context.commit("clearSession");
        context.dispatch("account/clear", null, { root: true });
      });
  }
};

const getters = {
  getSession: state => {
    return state.session;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
